function ClickAllRefreshButtons() {
  const buttons = document.querySelectorAll('.btn-refresh');
  buttons.forEach(button => button.click());
}

export default ClickAllRefreshButtons
